import React from "react";
import { Sticky, StickyProps } from "react-sticky";

import { Container } from "./Container";
import { StyledPaper } from "./StyledPaper";

interface IStickyPaperProps {
  relativeSticky?: StickyProps["relative"];
}

const StickyPaper: React.FC<IStickyPaperProps> = ({ children, relativeSticky }) => (
  <Container>
    <Sticky relative={relativeSticky}>
      {({ isSticky }) => <StyledPaper isSticky={isSticky}>{children}</StyledPaper>}
    </Sticky>
  </Container>
);

StickyPaper.defaultProps = {
  relativeSticky: false
};

export { StickyPaper };
